import React from 'react';
import { Formik, Field } from 'formik';
import { FormGroup, Form, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import '../../ProfilePage/styles.scss';
import CustomSelect from '../../../components/CustomSelect';
import PrimaryButton from '../../../components/PrimaryButton';

import '../styles.scss';

const LanguageForm = ({ formTitle, onSubmit, initialValues }) => {
  const { t } = useTranslation('account');
  return (
    <div className="form-wrappers">
      <h2>{formTitle}</h2>
      <Formik initialValues={initialValues} touchOnChange enableReinitialize onSubmit={values => onSubmit(values)}>
        {({ values, handleSubmit, isSubmitting }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormGroup className={'m-0'}>
                <Label className="profile-select-label">{t('language.label')}</Label>
                <Field
                  className="styled-field"
                  component={CustomSelect}
                  isSearchable={false}
                  name="language"
                  isClearable={false}
                  options={[
                    {
                      label: t('language.values.de'),
                      value: 'de',
                    },
                    {
                      label: t('language.values.fr'),
                      value: 'fr',
                    },
                    {
                      label: t('language.values.it'),
                      value: 'it',
                    },
                    {
                      label: t('language.values.en'),
                      value: 'en',
                    },
                  ]}
                  placeholder={t('language.placeholder')}
                />
              </FormGroup>
              <PrimaryButton type="submit" disabled={isSubmitting || initialValues?.language === values?.language}>
                {t('saveButton')}
              </PrimaryButton>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default LanguageForm;
